import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { RfpProOfferCompletePage } from '@/pages/rfp/professional/offer/RfpProOfferComplete/RfpProOfferCompletePage';
/**
 * コンサルタント：案件提案提出ページのロジック部分
 * NOTE: リダイレクト等が必要な場合はここで設定する
 */
export const RfpProOfferComplete = (props) => {
    const { rfp } = props;
    return _jsx(RfpProOfferCompletePage, { rfp: rfp });
};
